import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import ContactVerificationPrompt from "../../common/components/ContactVerificationPrompt";
import {
  CONTACT_VERIFICATION_ROLE,
  markContactVerificationPromptShown,
} from "../../common/utils/contactVerification";
import { resolveHomeVerificationPrompt } from "../../common/utils/homeVerificationPrompt";
import { getSessionContext } from "../../common/utils/sessionContext";
import { removerFromLocalStorage } from "../../common/utils/localStorage";
import { BiTask } from "react-icons/bi";
import { FaCheckCircle } from "react-icons/fa";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { BsChatLeftText } from "react-icons/bs";
import { BsQrCodeScan } from "react-icons/bs";

const Home = () => {
  const { residentId, caregiverCheckinId, communityFlag, communityName } = getSessionContext();
  const hasResidentId = !!residentId;
  const hasCaregiverCheckinId = !!caregiverCheckinId;
  const hideCheckinMenu = hasResidentId && hasCaregiverCheckinId;
  const navigate = useNavigate();
  const [showVerificationPrompt, setShowVerificationPrompt] = useState(false);
  const [verificationPromptMessage, setVerificationPromptMessage] = useState("");

  /*
  useEffect(() => {
    let cancelled = false;

    const loadVerificationPrompt = async () => {
      const result = await resolveHomeVerificationPrompt(CONTACT_VERIFICATION_ROLE.CAREGIVER);
      if (cancelled || !result.shouldShow) {
        return;
      }

      setVerificationPromptMessage(result.message);
      setShowVerificationPrompt(true);
      markContactVerificationPromptShown(CONTACT_VERIFICATION_ROLE.CAREGIVER);
    };

    loadVerificationPrompt();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleCloseVerificationPrompt = () => {
    setShowVerificationPrompt(false);
    markContactVerificationPromptShown(CONTACT_VERIFICATION_ROLE.CAREGIVER);
  };
  */

  const handleChange = (e, pathname) => {
    e.preventDefault();
    navigate("/" + pathname);
  };

  const backToCommunitySelection = () => {
    removerFromLocalStorage("communityId");
    removerFromLocalStorage("communityName");
    navigate("/select-community");
  };

  const showBackIcon = communityFlag == 1;

  return (
    <>
      <Header />
      <div className="home-container">
        <div className="change-community-btn">
          <div className="back-icon-container">{showBackIcon && <IoChevronBackCircleSharp className="vitals-preview-header" onClick={backToCommunitySelection} style={{fontSize:'30px'}} />}</div>
          <span className="welcome-title">
            <span className="welcome-title-main">Welcome to {communityName}!</span>
            <br />
            <span className="welcome-title-sub">Choose what you'd like to do next.</span>
          </span>
          <div className="back-icon-container" />
        </div>
        <div className="home-inner-container spaceAround" style={{ height: "80%" }}>
          {!hideCheckinMenu && (
            <div className="home-menus col-8 col-sm-8 col-md-8 col-lg-4 col-xl-4" onClick={(e) => handleChange(e, "new-checkin")}>
              <FaCheckCircle className="caregiver-menu-icons" />
              <span>Checkin</span>
            </div>
          )}
           <div className="home-menus col-8 col-sm-8 col-md-8 col-lg-4 col-xl-4" onClick={(e) => handleChange(e, "all-notes")}>
            <BsChatLeftText className="caregiver-menu-icons" />
            <span>Notes</span>
          </div>
          
          <div className="home-menus col-8 col-sm-8 col-md-8 col-lg-4 col-xl-4" onClick={(e) => handleChange(e, "caregiver-task")}>
            <BiTask className="caregiver-menu-icons" />
            <span>Task</span>
          </div>
        </div>
      </div>
      {/*
      <ContactVerificationPrompt
        open={showVerificationPrompt}
        onClose={handleCloseVerificationPrompt}
        role={CONTACT_VERIFICATION_ROLE.CAREGIVER}
        message={verificationPromptMessage}
      />
      */}
    </>
  );
};

export default Home;
